export var safeParseNumber = function (value) {
    if (value === null || value === undefined)
        return undefined;
    var num = Number(value);
    return isNaN(num) ? undefined : num;
};
